import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { ApimSubscriptionsService } from './apim-subscriptions.service';
import { SubscriptionModel } from './models/subscription-model';

@Component({
  selector: 'app-apim-subscriptions',
  standalone: true,
  imports: [CommonModule, KENDO_GRID],
  templateUrl: './apim-subscriptions.component.html',
})
export class ApimSubscriptionsComponent implements OnInit {
  public subscriptions: SubscriptionModel[] = [];
  public loading: boolean = false;
  public error: string | null = null;

  constructor(private subscriptionsService: ApimSubscriptionsService) {}

  ngOnInit(): void {
    this.loadSubscriptions();
  }

  private loadSubscriptions(): void {
    this.loading = true;
    this.error = null;
    this.subscriptionsService.getSubscriptions('item-store').subscribe({
      next: (data) => {
        this.subscriptions = data;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading subscriptions:', err);
        this.error = 'Failed to load subscriptions. Please try again.';
        this.loading = false;
      },
    });
  }
}
